module.exports = __webpack_public_path__ + "img/phone-icon.b7f55f80.svg";